import { render } from "./CustomerDocuments.vue?vue&type=template&id=64d7f260&scoped=true"
import script from "./CustomerDocuments.vue?vue&type=script&lang=js"
export * from "./CustomerDocuments.vue?vue&type=script&lang=js"

import "./CustomerDocuments.vue?vue&type=style&index=0&id=64d7f260&scoped=true&lang=css"
/* custom blocks */
import block0 from "./CustomerDocuments.vue?vue&type=custom&index=0&blockType=svg&width=28&height=28&viewBox=0%200%2028%2028&fill=none"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d7f260"]])

export default __exports__